"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorDisabled = exports.makePalette = void 0;
var styles_1 = require("@mui/material/styles");
var WCAG_AA_CONTRAST_RATIO = 4.5;
var makePalette = function (theme) {
    var _a;
    var primaryColor = (_a = theme === null || theme === void 0 ? void 0 : theme.primaryColor) === null || _a === void 0 ? void 0 : _a.value;
    if (primaryColor) {
        while ((0, styles_1.getContrastRatio)(primaryColor, '#fff') < WCAG_AA_CONTRAST_RATIO) {
            primaryColor = (0, styles_1.darken)(primaryColor, 0.1);
        }
    }
    var palette = {
        primary: __assign({}, (primaryColor && { main: primaryColor })),
    };
    return { palette: palette };
};
exports.makePalette = makePalette;
var colorDisabled = function (color) {
    try {
        return {
            color: (0, styles_1.alpha)(color.contrastText, 0.75),
            backgroundColor: (0, styles_1.alpha)(color.main, 0.6),
        };
    }
    catch (e) {
        console.error(e.stack);
    }
};
exports.colorDisabled = colorDisabled;
//# sourceMappingURL=utils.js.map